import { AutoColumn } from 'components/Column'
import { SwitchLocaleLink } from 'components/SwitchLocaleLink'
import { useEffect, useMemo, useState } from 'react'
import { Link, Route, Switch, Redirect, useRouteMatch } from 'react-router-dom'
import styled, { keyframes } from 'styled-components/macro'
import { useIncentiveSubgraph } from '../../hooks/useIncentiveSubgraph'
import { AlignJustify, Award, ExternalLink } from 'react-feather'
import { Checkbox } from './Checkbox'
import { NONFUNGIBLE_POSITION_MANAGER_ADDRESSES } from '../../constants/addresses'
import { useStakerHandlers } from '../../hooks/useStakerHandlers'
import { useActiveWeb3React } from '../../hooks/web3'
import { useAllTransactions } from '../../state/transactions/hooks'
import Loader from '../../components/Loader'
import { StakingMenu } from '../../components/StakingMenu'
import { PageTitle } from '../../components/PageTitle'
import { RedirectDuplicateTokenInfiniteFarmingIds } from './redirects'
import { getCountdownTime } from '../../utils/time'
import { useWalletModalToggle } from '../../state/application/hooks'
import { deviceSizes } from '../styled'

import { Helmet } from 'react-helmet'
import { NewInfiniteFarming } from './NewInfiniteFarming'

const PageWrapper = styled(AutoColumn)`
  max-width: 900px;
  width: 100%;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    max-width: 800px;
  `};

  ${({ theme }) => theme.mediaWidth.upToSmall`
    max-width: 600px;
  `};
`
const InnerWrapper = styled(AutoColumn)`
  ${({ theme }) => theme.mediaWidth.upToSmall`{
    min-width: 100%;
  }`}
`
const MainContentWrapper = styled.div`
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  ${({ theme }) => theme.mediaWidth.upToSmall`{
    min-width: 100%;
  }`}
`
const MenuWrapper = styled.div`
  width: 100%;
  margin-bottom: 2rem;

  ${({ theme }) => theme.mediaWidth.upToSmall`{
    min-width: calc(100% + 3rem);
    overflow: auto;
    margin: 0 -2rem 1rem -2rem;
    padding: 0 1rem;
  }`}
`

const MockScreen = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
`

const ConnectWalletButton = styled.button`
  border: 1px solid #5d32ed;
  background-color: #5d32ed;
  color: white;
  padding: 8px 12px;
  font-size: 16px;
  border-radius: 10px;
`

export default function InfiniteFarmingPage() {
  const { account } = useActiveWeb3React()

  const { fetchRewards, fetchCurrentEvents, fetchFutureEvents, fetchTransferredPositions } =
    useIncentiveSubgraph() || {}

  const [now, setNow] = useState(Date.now())

  useEffect(() => {
    const timeNow = setInterval(() => setNow(Date.now()), 1000)
    return () => {
      clearInterval(timeNow)
    }
  }, [])

  const { path } = useRouteMatch()

  const toggleWalletModal = useWalletModalToggle()

  return (
    <>
      <Helmet>
        <title>Algebra — Infinite Farming</title>
      </Helmet>
      <PageWrapper>
        <InnerWrapper gap="lg" justify="center">
          <InnerWrapper gap="lg" style={{ width: '100%', gridRowGap: '0' }}>
            <MainContentWrapper>
              <Switch>
                <Route exact path={`${path}`}>
                  <Redirect to={`${path}/${account ? 'create-event' : ''}`} />
                </Route>
                <Route
                  exact
                  strict
                  render={(props) => (
                    <>
                      <Helmet>
                        <title>Algebra — Infinite Farming • Create event</title>
                      </Helmet>
                      <PageTitle title={'Create Infinite event'}></PageTitle>
                        {console.log(props)}
                      <NewInfiniteFarming {...props}></NewInfiniteFarming>
                    </>
                  )}
                  path={`${path}/create-event`}
                ></Route>
                <Route
                  exact
                  strict
                  render={(props) => (
                    <>
                      <Helmet>
                        <title>Algebra — Farming • Create event</title>
                      </Helmet>
                      <PageTitle title={'Create Infinite event'}></PageTitle>
                      <RedirectDuplicateTokenInfiniteFarmingIds {...props}></RedirectDuplicateTokenInfiniteFarmingIds>
                    </>
                  )}
                  path={`${path}/create-event/:currencyIdA?/:currencyIdB?/:rewardTokenId?/:bonusRewardTokenId?/:lockedTokenId?`}
                ></Route>
              </Switch>
            </MainContentWrapper>
          </InnerWrapper>
        </InnerWrapper>
      </PageWrapper>
      <SwitchLocaleLink />
    </>
  )
}
